import { useEffect, useState } from 'react'
import { DARK_MODE_KEY } from '@signal/theme/variables'
import { setColorScheme } from '@signal/theme/utils/setColorScheme'
import { setCookie, readCookie } from '@signal/utils/cookies'
import { GENERIC_PURECARS_DOMAIN } from '@signal/utils/constants'

export const useAppDarkMode = tenantTheme => {
  const canUseDarkMode = tenantTheme ? tenantTheme.isDefaultTheme : false
  const [isDarkMode, setDarkMode] = useState(false)

  useEffect(() => {
    if (!canUseDarkMode) {
      return
    }

    const isDarkModeSet = readCookie(DARK_MODE_KEY)

    // Assure the value is set
    if (
      !isDarkModeSet ||
      typeof isDarkModeSet !== 'string' ||
      (isDarkModeSet !== 'true' && isDarkModeSet !== 'false')
    ) {
      setCookie({
        name: DARK_MODE_KEY,
        value: 'false',
        expiry: 365,
        domain: GENERIC_PURECARS_DOMAIN
      })
      return
    }

    const isDark = isDarkModeSet === 'true'

    setColorScheme(isDark)
    setDarkMode(isDark)
  }, [canUseDarkMode])

  const setIsDarkMode = dark => {
    setColorScheme(dark)
    setCookie({
      name: DARK_MODE_KEY,
      value: dark,
      expiry: 365,
      domain: GENERIC_PURECARS_DOMAIN
    })
    setDarkMode(dark)
  }

  return {
    isDarkMode,
    setIsDarkMode
  }
}
